import React, { useEffect, useState } from 'react';
import { Sidebar } from 'primereact/sidebar';
import TabClientes from './TabClientes';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Link } from "react-router";
import md5 from 'md5';


export default function SidebarRelatoriosClientes(props) {
    const { clientes, setCliente, dataEmpresa } = props;
    const [visible, setVisible] = useState(false)
    const [index, setIndex] = useState(0);
    const [opcaoSelecionada, setOpcaoSelecionada] = useState(props.fixarCliente ? props.dataEmpresa.idcliente: -1);
    const [clienteSelecionada, setClienteSelecionada] = useState(-1);
    const [dataInicial, setDataInicial] = useState('')
    const [dataFinal, setDataFinal] = useState('')
    const [hashReport , setHashReport]= useState('')
    const [reportOptions, setReportOptions]= useState('')
    const customHeader = (
        <div className="flex align-items-center gap-2">           
            <span className="font-bold text-xl">Gestão Relatórios </span>
        </div>
    );

    const opcoes = [
    { label: 'Data de Consulta', value: 'dataConsulta' },
    { label: 'Data de Cadastro', value: 'dataCadastro' },
    
    ];

    const sidebarStyle = {
        minWidth: props.isMobile ? '100%' : (index > 0 ? '70%' : '45%'),
        transition: 'all 0.5s ease-in-out',
        animation: visible ? 'fadeInSidebar 0.3s ease-out' : ''
    };

    const baseUrl = "https://datacount.com.br/webapi/index.php/relatoriosController/";
    
    const token = '9f5c30eab8c4644b5a8da4ddcb263c75';

    useEffect(()=>{ 
        setReportOptions(getDataUrlReports())    
    }, [clienteSelecionada, dataInicial, dataFinal, opcaoSelecionada])

     useEffect(()=>{ 
        if(visible){
            if(props.fixarCliente){
                setClienteSelecionada(props.clientes?.idcliente)
              
                return
            }
            
        } 
    }, [visible])

    useEffect(()=>{
        if(visible){
          //  alert('teste inicial')
            if(props.fixarCliente ){
                setClienteSelecionada(()=>dataEmpresa.idcliente)
              //  alert('Opção cliente fixo')
                return
            }
            if(props.clientes?.length === 1 ){
                setClienteSelecionada(()=>props.clientes)
              //  alert('Opcao de apenas um cliente listado')
                return

            }else{
              //  alert('Todos os clientes listados')
                setClienteSelecionada(()=>-1)

            }
        }
        

    }, [visible])

    

    const getDataUrlReports = () =>{
        const codigoCliente = props.fixarCliente ? props.clientes?.idcliente : clienteSelecionada
        return [
        {
            report : 'Descobertas Recentes',
            icon : 'pi pi-objects-column', 
            html : baseUrl+'getDataDescobertasReport?action='+token+'&idempresa='+dataEmpresa.idempresa+
            '&dataInicial='+dataInicial+'&dataFinal='+dataFinal+'&tipoData='+opcaoSelecionada+'&idcliente='+codigoCliente+'&oauth='+md5(dataEmpresa.idempresa)+'&oauth2='+((dataEmpresa.idempresa) * 3)+'&tipo=', 
        disabled : false,
        
        }, 
        {
            report : 'Visão de Parque',
            icon : 'pi pi-objects-column', 
            html : baseUrl+'getDataVisaoParqueReport?action='+token+'&idempresa='+dataEmpresa.idempresa+
            '&dataInicial='+dataInicial+'&dataFinal='+dataFinal+'&tipoData='+opcaoSelecionada+'&idcliente='+codigoCliente+'&oauth='+md5(dataEmpresa.idempresa)+'&oauth2='+((dataEmpresa.idempresa) * 3)+'&tipo=', 
        disabled : false,
        
        }, 
        {
            report : 'Equipamentos OnLine',
            icon : 'pi pi-objects-column', 
            html : baseUrl+'getDataOnLineReport?action='+token+'&idempresa='+dataEmpresa.idempresa+
            '&dataInicial='+dataInicial+'&dataFinal='+dataFinal+'&tipoData='+opcaoSelecionada+'&idcliente='+codigoCliente+'&oauth='+md5(dataEmpresa.idempresa)+'&oauth2='+((dataEmpresa.idempresa) * 3)+'&tipo=', 
        disabled : false,
        
        }, 
        {
            report : 'Sem Conexão',
            icon : 'pi pi-objects-column', 
            html : baseUrl+'getDataDesconectadasReport?action='+token+'&idempresa='+dataEmpresa.idempresa+
            '&dataInicial='+dataInicial+'&dataFinal='+dataFinal+'&tipoData='+opcaoSelecionada+'&idcliente='+codigoCliente+'&oauth='+md5(dataEmpresa.idempresa)+'&oauth2='+((dataEmpresa.idempresa) * 3)+'&tipo=', 

        
        }, 
        {
            report : 'Desabilitados',
            icon : 'pi pi-objects-column', 
            html : baseUrl+'getDataDesabilitadasReport?action='+token+'&idempresa='+dataEmpresa.idempresa+
            '&dataInicial='+dataInicial+'&dataFinal='+dataFinal+'&tipoData='+opcaoSelecionada+'&idcliente='+codigoCliente+'&oauth='+md5(dataEmpresa.idempresa)+'&oauth2='+((dataEmpresa.idempresa) * 3)+'&tipo=', 
        disabled : false,
        
        }, 
        {
            report : 'Status do parque',
            icon : 'pi pi-objects-column', 
            html : baseUrl+'getDataStatusParqueReport?action='+token+'&idempresa='+dataEmpresa.idempresa+
            '&dataInicial='+dataInicial+'&dataFinal='+dataFinal+'&tipoData='+opcaoSelecionada+'&idcliente='+codigoCliente+'&oauth='+md5(dataEmpresa.idempresa)+'&oauth2='+((dataEmpresa.idempresa) * 3)+'&tipo=', 
       disabled : false,
        
        }, 
        {
            report : 'Alertas suprimentos',
            icon : 'pi pi-objects-column', 
            html : baseUrl+'getDataAlertasSuprimentoReport?action='+token+'&idempresa='+dataEmpresa.idempresa+
            '&dataInicial='+dataInicial+'&dataFinal='+dataFinal+'&tipoData='+opcaoSelecionada+'&idcliente='+codigoCliente+'&oauth='+md5(dataEmpresa.idempresa)+'&oauth2='+((dataEmpresa.idempresa) * 3)+'&tipo=', 
           disabled : false,
        
        }, 
        {
            report : 'Trocas prematuras',
            icon : 'pi pi-objects-column', 
            html : baseUrl+'getDataTrocasSuprimentoReport?action='+token+'&idempresa='+dataEmpresa.idempresa+
            '&dataInicial='+dataInicial+'&dataFinal='+dataFinal+'&tipoData='+opcaoSelecionada+'&idcliente='+codigoCliente+'&oauth='+md5(dataEmpresa.idempresa)+'&oauth2='+((dataEmpresa.idempresa) * 3)+'&tipo=', 
            disabled : false,
        
        }, 
        {
            report : 'Situações de DCAs',
            icon : 'pi pi-objects-column', 
            html : baseUrl+'getDataDcaStatusReport?action='+token+'&idempresa='+dataEmpresa.idempresa+
            '&dataInicial='+dataInicial+'&dataFinal='+dataFinal+'&tipoData='+opcaoSelecionada+'&idcliente='+codigoCliente+'&oauth='+md5(dataEmpresa.idempresa)+'&oauth2='+((dataEmpresa.idempresa) * 3)+'&tipo=', 
           disabled : false,
        
        }, 
        {
            report : 'Contadores Diários',
            icon : 'pi pi-objects-column', 
            html : baseUrl+'relatorioContadorDiarioGraficoPeriodo?action='+token+'&idempresa='+dataEmpresa.idempresa+
            '&dataInicial='+dataInicial+'&dataFinal='+dataFinal+'&tipoData='+opcaoSelecionada+'&idcliente='+codigoCliente+'&oauth='+md5(dataEmpresa.idempresa)+'&oauth2='+((dataEmpresa.idempresa) * 3)+'&tipo=', 
            disabled : false,
        
        }, 
        {
            report : 'Equipamentos Revenda',
            icon : 'pi pi-objects-column', 
            html : baseUrl+'getDataRelatoriosCobranca?action='+btoa("idusuario="+dataEmpresa.idrevenda+"&idcliente="+codigoCliente+"&tipo=&dataInicial="+dataInicial)+'&oauth='+md5(dataEmpresa.idempresa)+'&oauth2='+((dataEmpresa.idempresa) * 3)+'&tipo=', 
            disabled : true,
        }
    ]
    }
  

    const openLink = (data, disabled) =>{
        if(disabled){
            props.showMessage('warn', 'Você não tem permissão para acessar este recurso!')
            return
        }
        console.log(data)
        window.open(data, '_blank')
    }

    

    function formatDateToYMD(date) {
        if (!date || !(date instanceof Date)) return date;
        
        const year = date.getFullYear(); // ← sempre retorna 4 dígitos
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }


    return (
        <>
        <Button 
            icon="pi pi-print" 
            className= "p-button-primary p-button-sm" 
            onClick={()=>{
                setVisible(true)
            }} 
            label='Relatórios Contadores'
            tooltip="Relatórios" tooltipOptions={{ position: 'bottom' }}
        /> 
        <Sidebar 
            onHide={() => {
               setVisible(!visible)
            }}
            
            header={customHeader} 
            visible={visible} 
            style={sidebarStyle} 
            position="right" 
            className="custom-sidebar"

        >
            <div className="flex flex-wrap gap-0">
                <div className="col-12 md:col-3">
                     <div className="flex-auto">
                        <label htmlFor="buttondisplay" className="font-bold block mb-2">
                            Data Inicial
                        </label>
                        <Calendar 
                            id="buttondisplay"  
                      
                            onChange={(e) => setDataInicial(formatDateToYMD(e.value))}
                            dateFormat="dd/mm/yy"
                            showIcon
                            showButtonBar
                            placeholder="Selecione a data"  
                            className='w-full'/>
                    </div>
                </div>
                <div className="col-12 md:col-3">
                     <div className="flex-auto">
                        <label htmlFor="buttondisplay" className="font-bold block mb-2">
                            Data Final
                        </label>
                        <Calendar 
                            id="buttondisplay"
                            
                            onChange={(e) => setDataFinal(formatDateToYMD(e.value))}
                            dateFormat="dd/mm/yy"
                            showIcon
                            showButtonBar
                            placeholder="Selecione a data"  
                            className='w-full'/>
                    </div>

                </div>
                <div className="col-12 md:col-6">
                     <div className="flex-auto">
                        <label htmlFor="buttondisplay" className="font-bold block mb-2">
                            Tipo de Data
                        </label>
                        <Dropdown
                            value={opcaoSelecionada}
                            options={opcoes}
                            onChange={(e) => setOpcaoSelecionada(e.value)}
                            placeholder="Selecione"
                            className="w-full h-full"
                        />
                    </div>
                </div>
            </div>

            <div className="flex flex-wrap gap-0">
                <div className="col-12 md:col-12">
                     <div className="flex-auto">
                        <label htmlFor="buttondisplay" className="font-bold block mb-2">
                            Cliente
                        </label>
                        {
                            props.fixarCliente ? 
                            <select                             
                                value={ clienteSelecionada} 
                                disabled
                                onChange={(e)=>setClienteSelecionada(e.target.value)}
                                class="custom-select"> 
                                <option value={props.clientes?.idcliente}>{props.clientes?.razaosocial}</option>
                            </select>
                            : 
                            
                            <select                             
                                value={ clienteSelecionada} 
                                onChange={(e)=>setClienteSelecionada(e.target.value)}
                                class="custom-select">
                                <option value={-1}>Todos</option>
                                {
                                    props.clientes && props.clientes.length > 1 ?  props.clientes.map(function(dataCliente){
                                        return <option value={dataCliente.idcliente}>{dataCliente.razaosocial}</option>
                                    }) : null
                                }
                            </select>
                        }

               
                    </div>
                </div>
            </div>

            <div className='p-2'>
                <DataTable 
                    style={{marginTop : '10px'}}
                    value={reportOptions}
                    paginator                 
                    rows={15} // Número de itens por página
                    rowsPerPageOptions={[10, 15, 20, 25]} // Opções de páginas
                    responsiveLayout="scroll"
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                    currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords}"
                    tableStyle={{ minWidth: '35rem', fontSize : '11px' }}
                    bodyStyle={{fontSize : '10px'}}                            
                    filterDisplay="menu"// Exibe os filtros como menu pop-up
                >
                    <Column 
                        header='Report Name' 
                        style={{width : '80%', fontSize : '14px', paddingTop: '3px'}}
                        body ={(row)=>row.report}/>
                    <Column
                        header='CSV' 
                        style={{width : '10%', paddingTop: '3px'}}
                        body ={(row)=><i className='pi pi-list-check icon-hover text-3xl' onClick={()=>{
                            openLink(row.html+'excel', row.disabled)
                        }} style={{cursor : 'pointer'}}/>
                        }/>
                    <Column
                        header='HTML' 
                        style={{width : '10%', paddingTop: '3px'}}
                        body ={(row)=><i className='pi pi-file-plus icon-hover text-3xl' onClick={()=>{
                           
                            openLink(row.html+'html', row.disabled) 
                        }} style={{cursor : 'pointer'}}/>
                        }/>
                </DataTable>
             </div>

        </Sidebar>

        </>
    );
}
